import { Type } from "class-transformer";
import { DhcAstItem } from "./DhcAstItem";
import { DhcError } from "./DhcError";

export class DhcParsed {
    code: string;
    @Type(() => DhcError)
    errors: DhcError[];
    @Type(() => DhcAstItem)
    ast: DhcAstItem;
}
